<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'RedoBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'redo',
      title: 'Redo',

      hotkey: ['ctrl+shift+z', 'meta+shift+z'],
    };
  },
  computed: {
    show() {
      return false;
    },
  },
  methods: {
    action() {
      this.redo();
    },
    redo() {
      this.canvas.redo();
    },
  },
};
</script>
